var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceStamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8327 10.875L10.8743 16.8334C10.7077 17 10.5202 17.125 10.3118 17.2084C10.1035 17.2917 9.89518 17.3334 9.68685 17.3334C9.47852 17.3334 9.27018 17.2917 9.06185 17.2084C8.85352 17.125 8.66602 17 8.49935 16.8334L1.14518 9.47919C0.992405 9.32641 0.874349 9.14946 0.791016 8.94835C0.707682 8.74724 0.666016 8.5353 0.666016 8.31252V2.33335C0.666016 1.87502 0.829349 1.4828 1.15602 1.15669C1.48268 0.830576 1.8749 0.667243 2.33268 0.666687H8.31185C8.53407 0.666687 8.74935 0.711965 8.95768 0.80252C9.16602 0.893076 9.34657 1.01446 9.49935 1.16669L16.8327 8.52085C16.9993 8.68752 17.121 8.87502 17.1977 9.08335C17.2743 9.29169 17.3124 9.50002 17.3118 9.70835C17.3113 9.91669 17.2732 10.1217 17.1977 10.3234C17.1221 10.525 17.0005 10.7089 16.8327 10.875ZM4.41602 5.66669C4.76324 5.66669 5.05852 5.5453 5.30185 5.30252C5.54518 5.05974 5.66657 4.76446 5.66602 4.41669C5.66546 4.06891 5.54407 3.77391 5.30185 3.53169C5.05963 3.28946 4.76435 3.1678 4.41602 3.16669C4.06768 3.16558 3.77268 3.28724 3.53102 3.53169C3.28935 3.77613 3.16768 4.07113 3.16602 4.41669C3.16435 4.76224 3.28602 5.05752 3.53102 5.30252C3.77602 5.54752 4.07102 5.66891 4.41602 5.66669Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceStamp);
export default __webpack_public_path__ + "static/media/priceStamp.a8da3fcd86327d245215145906821122.svg";
export { ForwardRef as ReactComponent };